import React from "react";

const Templates = () => {
  return <div></div>;
};

export default Templates;
